
<div class="original-form">
  <header class="dialog-header">
    <h2 mat-dialog-title>{{ (data.recordType === 'inquiry' ? 'inquiryDetails' : 'claimDetails') | translate }}</h2>
    <button type="button" class="close-button" mat-dialog-close [attr.aria-label]="'close' | translate">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>
  <mat-dialog-content>
    <div class="overview-grid">
      <section class="overview-card">
        <button
          type="button"
          class="record-link"
          (click)="openVessel()"
        >
          {{ data.vessel?.name || data.vessel?.otherName }}
        </button>
        <div class="overview-line">
          <span>{{ "shipyard" | translate }}</span>
          <button
            type="button"
            class="inline-link"
            (click)="openShipyard()"
          >
            {{ data.shipyard?.name || data.shipyard?.otherName }}
          </button>
        </div>
        <div class="overview-line stacked-line">
          <span>{{ "vesselNumber" | translate }}</span>
          <strong>{{ data.vessel?.vesselNumber }}</strong>
        </div>
      </section>

      <section class="overview-card">
        <div class="record-link">
          {{ data.equipment?.name }}
        </div>
        <div class="overview-line">
          <span>{{ "serialNo" | translate }}</span>
          <strong>{{ data.equipment?.serialNumber }}</strong>
        </div>
        <div class="overview-line stacked-line">
          <span>{{ "prodNameAndType" | translate }}</span>
          <strong>
            {{ data.product?.name || "-" }} / 
            {{ data.category?.name || "-"  }}
          </strong>
        </div>
      </section>
    </div>

    <section class="incident-card">
      <h3>{{ "incidentDetails" | translate }}</h3>
      <div class="incident-meta">
        <div>
          <mat-icon aria-hidden="true">calendar_today</mat-icon>
          <span
            >{{ data.claim?.incidentDate | date: 'yyyy/MM/dd':'+0900' }}</span
          >
        </div>
        <div>
          <mat-icon aria-hidden="true">schedule</mat-icon>
          <span
            >{{ data.claim?.incidentDate | date: 'HH:mm':'+0900' }}
            JST</span
          >
        </div>
        <div>
          <mat-icon aria-hidden="true">location_on</mat-icon>
          <span>{{ data.claim?.incidentPlace }}</span>
        </div>
      </div>

      <div class="incident-answers">
        <div class="answer-block">
          <h4>{{ "incidentLeadup" | translate }}</h4>
          <p>{{ data.claim?.incidentLeadup }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "currStatus" | translate }}</h4>
          <p>{{ data.claim?.equipmentCurrentStatus }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "measuresTaken" | translate }}</h4>
          <p>{{ data.claim?.responseMeasures }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "detailsJRCS" | translate }}</h4>
          <p>{{ data.claim?.responseRequestDetails }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "otherDetailsJRCS" | translate }}</h4>
          <p>{{ data.claim?.extraDetails }}</p>
        </div>
      </div>

      <div class="attachment-gallery" *ngIf="data.files?.length">
        <div
          *ngFor="let file of data.files"
          class="attachment-card"
          role="button"
          tabindex="0"
          (click)="downloadFile(file.id, file.filename, file.filetype)"
          (keyup.enter)="downloadFile(file.id, file.filename, file.filetype)"
        >
          <div class="attachment-preview">
            <img
              *ngIf="file.filetype?.startsWith('image/') && file.previewUrl"
              [src]="file.previewUrl"
              [alt]="file.filename"
            />
            <mat-icon
              *ngIf="!file.filetype?.startsWith('image/') || !file.previewUrl"
              aria-hidden="true"
            >
              {{ file.filetype === 'application/pdf' ?
              'picture_as_pdf' : 'insert_drive_file' }}
            </mat-icon>
          </div>
          <div class="attachment-name" [title]="file.filename">
            {{ file.filename }}
          </div>
          <div class="attachment-meta">
            {{ formatFileSize(file.filesize) }}
          </div>
        </div>
      </div>
    </section>

    <section class="other-details-section">
      <h3>{{ "otherDetails" | translate }}</h3>
      <div class="other-details-grid">
        <div class="readout-card half-width">
          <span>{{ "vesselType" | translate }}</span>
          <strong>{{ data.vessel?.shipType }}</strong>
        </div>
        <div class="readout-card half-width">
          <span>{{ "imo" | translate }}</span>
          <strong>{{ data.vessel?.imo }}</strong>
        </div>
        <div class="readout-card half-width">
          <span>{{ "owner" | translate }}</span>
          <strong>{{ data.owner?.name }}</strong>
        </div>
        <div class="readout-card half-width">
          <span>{{ "companyName" | translate }}</span>
          <strong>{{ data.company?.name }}</strong>
        </div>
        <div class="readout-card third-width">
          <span>{{ "shipDeliveryDate" | translate }}</span>
          <strong>{{ data.equipment?.shipDeliveryDate }}</strong>
        </div>
        <div class="readout-card third-width">
          <span>{{ "retrofittingDate" | translate }}</span>
          <strong>{{ data.equipment?.retrofittingDate }}</strong>
        </div>
        <div class="readout-card third-width">
          <span>{{ "warranty" | translate }}</span>
          <strong
            >{{ data.equipment?.warrantyExpirationDate | date: 'yyyy/MM/dd':'+0900'
            }}</strong
          >
        </div>
      </div>
    </section>

    <section class="incident-card">
      <h3>{{ "contactInfo" | translate }}</h3>
      <div class="incident-answers">
        <div class="answer-block">
          <h4>{{ "companyContactName" | translate }}</h4>
          <p>{{ data.claim?.contactPersonName }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "contactEmail" | translate }}</h4>
          <p>{{ data.claim?.contactPersonEmail }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "contactPhone" | translate }}</h4>
          <p>{{ data.claim?.contactPersonPhone }}</p>
        </div>
        <div class="answer-block">
          <h4>{{ "contactAddress" | translate }}</h4>
          <p>{{ data.claim?.contactPersonAddress }}</p>
        </div>
      </div>
    </section>
    <section class="incident-card">
      <h3>{{ "nextPortDate" | translate }}</h3>
      <p>{{ data.claim?.expectedPortCall | date: 'yyyy/MM/dd HH:mm':'+0900' }}<span *ngIf="data.claim?.expectedPortCall"> JST</span></p>
      <h4>{{ "nextPortPlace" | translate }}</h4>
      <p>{{ data.claim?.nextPort }}</p>
    </section>
  </mat-dialog-content>
</div>